import React, { createContext, PropsWithChildren, useContext, useEffect, useState } from "react";
import { TreeWriteContext } from "./TreeContext";

interface PathContextType {
  path: string[];
  appendPath: (newPathSegment: string) => void;
}

const PathContext = createContext<PathContextType>({
  path: [],
  appendPath: () => {},
});

interface PathProviderProps {
  currentPath: string[];
}

export function PathProvider(props: PropsWithChildren<PathProviderProps>) {
  const [path, setPath] = useState<any[]>(props.currentPath);

  const appendPath = (segment: any) => {
    setPath((prevPath) => [...prevPath, segment]);
  };

  useEffect(() => {
    setPath(props.currentPath);
  }, [props.currentPath]);

  return <PathContext.Provider value={{ path, appendPath }}>{props.children}</PathContext.Provider>;
}

interface TreeBranchProps {
  name: string[] | string;
}

export function PathInfo(props: PropsWithChildren<TreeBranchProps>) {
  const { path } = useContext(PathContext);

  return <PathProvider currentPath={path.concat(props.name)}>{props.children}</PathProvider>;
}

function CurrentPathDisplay() {
  const { path } = useContext(PathContext);
  return <div>Current Path: {path.join(" / ")}</div>;
}

export const usePathContext = () => useContext<PathContextType>(PathContext);
